import { useQueryClient } from '@tanstack/react-query';

import {
  getAiProviderSettings,
  updateAiProviderSettings,
  UpdateAiProviderSettingsRequestDto,
} from '@/shared/api/ai-provider';
import { useAppMutation } from '@/shared/lib/useAppMutation';
import { useAppQuery } from '@/shared/lib/useAppQuery';

const queryKey = ['ai-provider-settings'] as const;

export function useAiProviderSettings(enabled = true) {
  return useAppQuery({
    queryKey,
    queryFn: getAiProviderSettings,
    enabled,
    customError: true,
  });
}

export function useUpdateAiProviderSettings() {
  const queryClient = useQueryClient();

  return useAppMutation({
    mutationFn: (data: UpdateAiProviderSettingsRequestDto) =>
      updateAiProviderSettings(data),
    customError: true,
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, data);
    },
  });
}
